import {
	ActionReducerMapBuilder,
	createSlice,
	isAnyOf,
	PayloadAction,
} from "@reduxjs/toolkit";
import { searchApi } from "../api/search-api";
import { searchQmiApi } from "../api/search-qmi-api";

export interface AppStatusAppState {
	appLoaded: boolean;
	firstSearchComplete: boolean;
	isMobile: boolean;
	reRenderMap: boolean;
	isAnchorClicked: boolean;
	isMobileCardOpen: boolean;
	isQmiFinder: boolean;
}

export const appStatusSlice = createSlice({
	name: "appStatus",
	initialState: {
		appLoaded: false,
		firstSearchComplete: false,
		isMobile: false,
		reRenderMap: false,
		isAnchorClicked: false,
		isMobileCardOpen: false,
		isQmiFinder: false,
	} as AppStatusAppState,

	reducers: {
		//Setting the first search complete status boolean
		setAppLoaded: (
			state: AppStatusAppState,
			action: PayloadAction<boolean>,
		) => {
			state.appLoaded = action.payload;
		},
		setFirstSearchComplete: (
			state: AppStatusAppState,
			action: PayloadAction<boolean>,
		) => {
			state.firstSearchComplete = action.payload;
		},
		setIsMobile: (state: AppStatusAppState, action: PayloadAction<boolean>) => {
			state.isMobile = action.payload;
		},
		setReRenderMap: (
			state: AppStatusAppState,
			action: PayloadAction<boolean>,
		) => {
			state.reRenderMap = action.payload;
		},
		setIsAnchorClicked: (
			state: AppStatusAppState, 
			action: PayloadAction<boolean>
		) => {
			state.isAnchorClicked = action.payload;
		},
		setIsMobileCardOpen: (
			state: AppStatusAppState, 
			action: PayloadAction<boolean>
		) => {
			state.isMobileCardOpen = action.payload;
		},
		setIsQmiFinder: (
			state: AppStatusAppState, 
			action: PayloadAction<boolean>
		) => {
			state.isQmiFinder = action.payload;
		},
		setInitialQmiFinderStateFromUrl: (
            state, action: PayloadAction<string>
        ) => {
			{
            let theUrl = new URL(action.payload.toLowerCase());

            //Remove any trailing slash before we split the path
            let urlPath = theUrl.pathname
            if(urlPath.endsWith("/"))
            {
                urlPath = urlPath.replace(/\/+$/, '');
            }
           
            //We want to show the Community Finder if we are at state level
            // split the url to check which level we are at.
            let urlParts = urlPath.split("/")
            if(urlParts.length > 2)
            {
                //Check to see if the homes param is available
                if(theUrl.searchParams.has("homes"))
                {
                    let homesValue = theUrl.searchParams.get("homes")

                    if(homesValue === "hotw")
                    {
                        //The homes param is there and is set to homes of the week, set boolean
                        state.isQmiFinder = true;
                    }
                }
            }
        }
		},
	},
	extraReducers: (builder: ActionReducerMapBuilder<AppStatusAppState>) => {
		builder.addMatcher(
			//This adds a listener to the getApiResults call, when that is fulfilled this code will be called.
			isAnyOf(
				searchApi.endpoints.getApiResults.matchFulfilled,
				searchQmiApi.endpoints.getQmiApiResults.matchFulfilled
			),
			(state, action) => {
				//Set the state flag that indicates if a search has been completed.
				state.firstSearchComplete = true;
			},
		);
	},
});

export const { setAppLoaded, setFirstSearchComplete, setIsMobile, setReRenderMap, setIsAnchorClicked, setIsMobileCardOpen, setIsQmiFinder, setInitialQmiFinderStateFromUrl } =
	appStatusSlice.actions;

export default appStatusSlice.reducer;
